import { PredefinedDashboard } from '../widgetDashboard.enums'
import { WidgetDashboardConfig } from '../widgetDashboard.interface'
import DashboardWrapper from './DashboardWrapper'

export class Layout_v4 extends DashboardWrapper {
    constructor() {
        super(PredefinedDashboard.LAYOUT_V4)
        this.dashboardConfig = {
            name: 'Untitled',
            panes: {
                id: 1,
                space: 100,
                horizontal: false,
                panes: [{
                    id: 2,
                    space: 25,
                    horizontal: true,
                    panes: []
                }, {
                    id: 3,
                    space: 25,
                    horizontal: true,
                    panes: []
                }, {
                    id: 4,
                    space: 25,
                    horizontal: true,
                    panes: []
                }, {
                    id: 5,
                    space: 25,
                    horizontal: true,
                    panes: []
                }]
            },
            singleMode: false,
            widgets: {},
            syncSettings: {
                security: false,
                crosshair: false,
                time: false,
                timeBucket: false,
                drawing: false
            }
        } as WidgetDashboardConfig
    }

}